"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var layout;
    (function (layout) {
        /**
         * Returns the correct values for the layout binding handler used by the radio button control
         * @param $data The binding context
         * @returns The $dyn.options for the layout binding handler
         */
        function radioButtonBinding($data) {
            return $dyn.options(function () {
                return {
                    arrangeMethod: $dyn.layout.ArrangeMethod.vertical,
                    children: $data.Items,
                    columns: $data.Columns,
                };
            }, $data.Updating);
        }
        layout.radioButtonBinding = radioButtonBinding;
    })(layout = $dyn.layout || ($dyn.layout = {}));
    var controls;
    (function (controls) {
        /**
         * Framework class for RadioButton controls
         */
        var RadioButton = /** @class */ (function (_super) {
            __extends(RadioButton, _super);
            function RadioButton() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            RadioButton.prototype.init = function (data, element) {
                var _this = this;
                _super.prototype.init.call(this, data, element);
                // Each enum value item must have a Visible property
                $dyn.observe(this.Items, function (value) {
                    if ((value) && (value.length)) {
                        var len = value.length;
                        for (var i = 0; i < len; i++) {
                            value[i].Visible = true;
                        }
                    }
                });
                $dyn.observe(this.shownIndex, function (newValue) {
                    if ($dyn.value(_this.isFocused)) {
                        _this.$cachedElement.find(".radioButton").eq(newValue).find("input").focus();
                    }
                });
            };
            /**
             * The focus in event handler
             */
            RadioButton.prototype.focusInCallBack = function () {
                this.isFocused(true);
                $dyn.log.focus && $dyn.log.focus("Focus: RadioButton->focusInCallBack input name: %s", this.Name);
            };
            /**
             * The focus out event handler
             */
            RadioButton.prototype.focusOutCallBack = function () {
                this.isFocused(false);
                $dyn.log.focus && $dyn.log.focus("Focus: RadioButton->focusOutCallBack input name: %s", this.Name);
            };
            /**
             * Function called before the foreach binding handler renders
             */
            RadioButton.prototype.preRenderCallBack = function () {
                if ($dyn.value(this.isFocused)) {
                    this.wasFocused = true;
                }
            };
            /**
             * Function called after the foreach binding handler renders
             */
            RadioButton.prototype.postRenderCallBack = function () {
                if (this.wasFocused) {
                    this.$cachedElement.find("[aria-checked]").focus();
                    this.wasFocused = false;
                }
            };
            RadioButton.prototype.getTaskGuideParams = function (options) {
                // As per 3794792, just point to the whole radiobuttion.
                options = _super.prototype.getTaskGuideParams.call(this, options);
                options.target = $(this.element);
                return options;
            };
            return RadioButton;
        }(controls.EnumControl));
        controls.RadioButton = RadioButton;
        RadioButton.prototype.Columns = "1";
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=RadioButton.js.map
